/**
 * Computes the validation-screen browser tab title, `{Project Name} - {Document Name}`.
 * Returns null until BOTH names are present, so callers render no title (and the
 * ancestor title shows through) rather than a partial/placeholder title.
 */
export default function getValidationTabTitle(
  projectName: string | null | undefined,
  documentName: string | null | undefined,
): string | null {
  if (!projectName || !documentName) return null
  return `${projectName} - ${documentName}`
}
